<template>
  <b-card>
    <b-row align-h="between">
      <b-col>
        <h4>Ancienneté d'emménagement dans la résidence principale</h4>
      </b-col>
      <b-col cols="3" class="text-right">
        <b-avatar
          size="32"
          variant="light-primary"
          v-b-tooltip.hover.v-primary
          title="Cet indicateur illustre la répartition des ménages selon le lieu de résidence un an auparavant dans la commune du programme ou adresse sélectionné au dernier recensement INSEE."
        >
          <feather-icon size="20" icon="HelpCircleIcon" />
        </b-avatar>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="12">
        <move-in-age-chart
          :demographyByPeriode="reportData.demographyByPeriode[0]"
        />
      </b-col>
      <b-col xl="12">
        <comment-form-text-area
          :enable="reportData.comments.moveInAge.enable"
          :commentField="reportData.comments.moveInAge.value"
          v-on:update:comment="reportData.comments.moveInAge.value = $event"
          v-on:update:enable="reportData.comments.moveInAge.enable = $event"
          v-on="$listeners"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, VBTooltip, BAvatar } from "bootstrap-vue";
import MoveInAgeChart from "./move-in-age-elements/MoveInAgeChart";
import CommentFormTextArea from "../../shared/CommentFormTextArea";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,

    // Components Vue
    MoveInAgeChart,
    CommentFormTextArea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.type-chart {
  width: 100%;
  height: 21rem;
}
</style>
